import React from 'react'
import {
  Modal,
  TextHeading,
  Button,
  TextBody,
  Space,
  Box,
  Link as MuiLink,
  useModalContext,
} from '@ally/metronome-ui'
import styled from 'styled-components'

const StyledButton = styled(Button)`
  display: inline;
`
const Trigger: React.FC = () => {
  const { setOpen } = useModalContext()
  return (
    <StyledButton
      variant="link"
      text="Call Us"
      onClick={(): void => setOpen(true)}
      data-testid="call-us-modal-trigger"
    />
  )
}
const headingRef = React.createRef<HTMLHeadingElement>()

export const ModalContent: React.FC = () => (
  <Box padding="lg">
    <TextHeading ref={headingRef} tag="h1" size="md" tabIndex={-1}>
      Your account needs attention.
    </TextHeading>
    <Space mb="md" mt="sm">
      <TextBody tag="p" size="sm">
        Due to your account status, some vehicle information or payment
        functionalities may not be available.
      </TextBody>
      <TextBody tag="p" size="sm">
        Please call{' '}
        <MuiLink
          data-testid="phone-link"
          text="1-888-925-2559"
          href="tel:18889252559"
          aria-label="1, 8 8 8, 9 2 5, 2 5 5 9"
        />{' '}
        for help.
      </TextBody>
    </Space>
  </Box>
)

const CallUsModal: React.FC = () => {
  return (
    <Modal
      trigger={<Trigger />}
      content={<ModalContent />}
      height="auto"
      width="md"
    />
  )
}

export default CallUsModal
